import { AppModules } from 'appContainer/types';
import { PathRouteContent, RouteNode } from 'router/declarative/routeNode';
import { UserSettingsTabs } from './types';

export const routes = {
  path: '/account-settings',
  title: 'Account settings',
  appModule: AppModules.USER_SETTINGS,
  content: async (): PathRouteContent =>
    (await import('./UserSettingsView')).UserSettingsView,
  children: [
    { path: `/${UserSettingsTabs.PROFILE}`, title: 'Profile' },
    { path: `/${UserSettingsTabs.EMAIL}`, title: 'Email settings' },
    { path: `/${UserSettingsTabs.API}`, title: 'API' },
    { path: `/${UserSettingsTabs.APPLICATIONS}`, title: 'Applications' },
    { path: `/${UserSettingsTabs.NOTIFICATIONS}`, title: 'Email preferences' },
    { path: `/${UserSettingsTabs.PASSWORD}`, title: 'Change password' },
  ],
} as const satisfies RouteNode;
